<template>
  <div class="activate-wrapper">
    <el-button type="primary" round size="mini" @click="handleOpen"
      >平台版激活</el-button
    >
    <el-dialog
      :visible.sync="dialogVisible"
      width="1000px"
      top="5vh"
      :before-close="() => (dialogVisible = false)"
    >
      <h3 slot="title">
        致小紫【卖家中心】供应商关于系统迁移至【小紫平台】的说明函
      </h3>
      <article>
        <p>尊敬的“小紫医疗”供应商：</p>
        <p>您好！</p>
        <p>
          首先，衷心感谢贵司长期以来对我司业务的支持与合作。随着公司业务快速发展及数字化转型的深入，为了更好的服务“小紫医疗”供应商，今年我们计划对【卖家中心】进行全面升级，具体升级内容及计划如下（具体开放时间请关注小紫医疗公众号或平台公告）：
        </p>
        <p class="block-wrapper">
          <span class="title"><img :src="stjc" />生态集成</span>
          <span class="content"
            >提供标准化API接口，便于与有开发能力的上下游合作伙伴进行系统对接，适配自身的业务扩展需求。</span
          >
        </p>
        <p class="block-wrapper">
          <span class="title"><img :src="ydbg" />移动办工</span>
          <span class="content"
            >支持移动端全流程操作，可满足远程协作、实时审批等场景，显著提升团队协同效率。</span
          >
        </p>
        <p class="block-wrapper">
          <span class="title"><img :src="sjts" />商机推送</span>
          <span class="content"
            >根据商家履约能力，开通【供需通】用户可以接收到精准商机，获取销售机会。</span
          >
        </p>
        <p class="block-wrapper">
          <span class="title"><img :src="ppyx" />品牌营销</span>
          <span class="content"
            >平台覆盖8000余家医械后市场相关企业，提升品牌曝光度、助力扩大企业影响力。</span
          >
        </p>
        <p class="block-wrapper">
          <span class="title"><img :src="syyy" />私域运营</span>
          <span class="content"
            >去中心化底层设计，为产业链上下游提供安全可靠的运营工具。</span
          >
        </p>
        <p class="block-wrapper">
          <span class="title"><img :src="yysd" />应用商店</span>
          <span class="content"
            >云市场商店提供专业、实惠的行业软件，实现核心企业内外协同，助力行业效率提升高质量发展。</span
          >
        </p>
        <p class="m-gap20">
          系统的稳定性和服务质量始终是我们认可的重要因素，【小紫平台】将承诺定期功能升级与快速响应服务，我们期待供应商尽快完成【小紫平台】的激活及认证，开启医械后市场产业互联办公的新模式。
        </p>
        <p class="description-wrapper">
          <span class="description">
            说明：本次迁移会保留原【卖家中心】所有数据，如您对此次调整有任何疑问或建议，请随时联系【杨经理：18930902542】，我们将全力配合沟通。再次感谢贵司的理解与支持！
          </span>
          <br />
          <span class="imgs-wrapper">
            <span>
              <img :src="kefu" /><br />
              平台客服
            </span>
            <span>
              <img :src="gongzhonghao" /><br />
              平台公众号
            </span>
          </span>
        </p>
        <p>顺祝商祺！</p>
        <p>小紫医疗运营中心</p>
        <p>2025年3月31日</p>
      </article>
      <template slot="footer">
        <el-button type="primary" @click="handleClose">前去激活</el-button>
      </template>
    </el-dialog>
    <el-dialog
      title="激活"
      :visible.sync="formDialogVisible"
      width="500px"
      custom-class="activate-dialog"
      :close-on-click-modal="false"
    >
      <el-form :model="form" :rules="rules" ref="form" label-width="8em">
        <el-form-item label="管理员姓名：">
          {{ adminName }}
        </el-form-item>
        <el-form-item label="管理员手机：">
          {{ adminPhoneNumber }}
        </el-form-item>
        <el-form-item label="激活验证码：" prop="validationCode">
          <el-input
            placeholder="请输入短信验证码"
            v-model="form.validationCode"
          >
            <i slot="prefix" class="el-input__icon el-icon-message"></i>
            <span slot="append" class="cursor-pointer" @click="sendCaptcha">{{
              loginMsgTip
            }}</span>
          </el-input>
        </el-form-item>
      </el-form>
      <el-checkbox v-model="agreementChecked">
        <span style="color: rgb(96, 98, 102)">已阅读并同意以下协议</span>
        <a
          v-for="a in agreementList"
          class="text-primary"
          :key="a.title"
          :href="a.href"
          target="_blank"
          >{{ a.title }}</a
        >
      </el-checkbox>
      <template slot="footer">
        <el-button type="primary" @click="handleActivate" :loading="isLogining"
          >一键激活</el-button
        >
      </template>
    </el-dialog>
    <el-dialog
      width="420px"
      :visible.sync="jumpDialogVisible"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <div class="title" slot="title">激活</div>
      <div class="tips">
        <i class="el-icon-success"></i>
        平台版激活成功，页面将在{{
          countDown
        }}s之后跳转至小紫平台，平台已将账号密码通过短信发送，请注意查收，如未收到短信，可用手机验证码进行登录操作
      </div>
      <div class="footer">
        <el-button type="primary" @click="jumpTo">立即跳转</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  activateSendCaptcha,
  activatePlatform,
  getXzptEmployeeDetail,
} from '@/api/login';
import { logout, detailSupplier } from '@/api/userCenter';

export default {
  watch: {
    '$store.state.User.currentSupplierId': {
      handler () {
        this.getDeatailInfo();
      },
      immediate: true,
    },
  },
  data () {
    return {
      ppyx: require('@/assets/imgs/ic_ppyx.png'),
      sjts: require('@/assets/imgs/ic_sjts.png'),
      stjc: require('@/assets/imgs/ic_stjc.png'),
      syyy: require('@/assets/imgs/ic_syyy.png'),
      ydbg: require('@/assets/imgs/ic_ydbg.png'),
      yysd: require('@/assets/imgs/ic_yysd.png'),
      kefu: require('@/assets/imgs/kefu.jpg'),
      gongzhonghao: require('@/assets/imgs/gongzhonghao.jpg'),
      isLogining: false,
      dialogVisible: false,
      formDialogVisible: false,
      jumpDialogVisible: false,
      form: {
        validationCode: '',
      },
      agreementChecked: false,
      loginMsgTimerId: null,
      agreementList: [
        {
          title: '《服务条款》',
          href: `${process.env.VUE_APP_PROTOCAL}xzfwtk.html`,
        },
        {
          title: '《隐私协议》',
          href: `${process.env.VUE_APP_PROTOCAL}xzysxy.html`,
        },
      ],
      loginMsgTip: '获取短信验证码',
      countDown: 5,
      timer: null,
      rules: {
        validationCode: [
          { required: true, message: '请输入短信验证码', trigger: 'blur' },
        ],
      },
      adminName: '',
      adminPhoneNumber: '',
    };
  },
  created () {
    this.initPage();
  },
  methods: {
    initPage () {
      this.$nextTick(() => {
        if (this.$store.state.common.isLogin) {
          this.handleOpen();
          this.$store.dispatch('changeIsLogin', '');
        }
      });
    },
    getDeatailInfo () {
      let currentParams = {
        id: this.$store.state.User.currentSupplierId,
      };
      detailSupplier(currentParams).then(({ body }) => {
        this.adminName = body.adminName;
        this.adminPhoneNumber = body.adminPhoneNumber;

        if (body.activatePlatformFlag) {
          this.jumpTo();
        }
      });
    },
    handleOpen () {
      this.dialogVisible = true;
    },
    handleClose () {
      this.dialogVisible = false;

      this.form.validationCode = '';
      this.agreementChecked = false;

      this.formDialogVisible = true;
    },
    handleLoginout () {
      logout().then(() => {
        this.$local.clear();
        this.$session.clear();
        this.$router.push({
          name: 'Login',
        });
      });
    },
    async jumpTo () {
      const { body } = await getXzptEmployeeDetail({
        phoneNumber: this.$store.state.User.userInfo.phone,
        supplierId: this.$store.state.User.currentSupplierId,
      });

      const currentCompany = this.$store.state.User.allCompanyLists.find(i => i.supplierId === this.$store.state.User.currentSupplierId);

      const info = JSON.stringify({
        password: body.password,
        phoneNumber: body.phoneNumber,
        xzptTenantId: currentCompany?.xzptTenantId || '',
        relogin: true,
      });

      const newWindow = window.open(`${process.env.VUE_APP_PLATFORM_ENV}/#/login?info=${encodeURIComponent(info)}`, '_blank');
      if (!newWindow) {
        this.$message.warning('弹窗被阻止，请点击立即跳转');
      } else {
        this.handleLoginout();
      }
    },
    setTimeoutCallback () {
      if (!this.countDown) {
        this.jumpTo();
      } else {
        setTimeout(() => {
          this.countDown--;
          this.setTimeoutCallback();
        }, 1000);
      }
    },
    handleActivate () {
      if (!this.agreementChecked) {
        this.$message({
          message: '请先阅读并同意协议',
          type: 'warning',
          center: true,
        });
        return;
      }

      if (this.isLogining) return;
      this.loginErrorMsg = '';
      this.$refs.form.validate().then((valid) => {
        if (valid) {
          this.isLogining = true;
          activatePlatform(this.form)
            .then(() => {
              this.formDialogVisible = false;
              this.jumpDialogVisible = true;
              this.countDown = 5;

              this.setTimeoutCallback();
            })
            .catch(() => {
              this.$alert(
                '<i class="el-icon-error" style="color: red; margin-right: 10px;"></i>平台版激活失败，请稍后激活',
                '激活',
                {
                  dangerouslyUseHTMLString: true,
                  confirmButtonText: '知道了',
                },
              );
            })
            .finally(() => {
              this.isLogining = false;
            });
        }
      });
    },
    sendCaptcha () {
      activateSendCaptcha({}).then(() => {
        if (!this.loginMsgTimerId) {
          this.loginMsgTimerTick = 120;
          this.loginMsgTimerId = setInterval(() => {
            this.loginMsgTimerTick--;
            this.loginMsgTip = `重新获取(${this.loginMsgTimerTick})`;
            if (this.loginMsgTimerTick === 0) {
              clearInterval(this.loginMsgTimerId);
              this.loginMsgTimerId = null;
              this.loginMsgTip = '获取短信验证码';
            }
          }, 1000);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}

.activate-wrapper {
  display: inline-block;
  margin-left: 10px;

  h3 {
    text-align: center;
  }

  article {
    padding: 0 20px 20px;

    p {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #303133;
      line-height: 1.8;

      &.block-wrapper {
        display: inline-block;
        width: 32%;
        padding: 10px;
        margin: 20px 2% 0 0;
        background: linear-gradient(
          145deg,
          rgba(222, 233, 250, 0.41) 0%,
          #e6eefd 100%
        );
        border-radius: 10px;
        opacity: 0.8;

        &:nth-child(3n) {
          margin-right: 0;
        }

        span {
          display: block;

          &.title {
            padding-left: 20px;
            position: relative;
            font-size: 16px;
            color: #333e5d;
            line-height: 22px;
            margin-bottom: 10px;

            img {
              position: absolute;
              width: 16px;
              height: 16px;
              top: 50%;
              left: 0;
              transform: translateY(-50%);
            }
          }

          &.content {
            font-weight: 400;
            font-size: 12px;
            color: #596ca1;
            line-height: 17px;
          }
        }
      }

      &.m-gap20 {
        margin: 20px 0;
      }

      &.description-wrapper {
        position: relative;
        .description {
          display: block;
          background: #f2f4f7;
          border-radius: 4px;
          opacity: 0.6;
          padding: 10px 20px 140px 20px;
        }

        .imgs-wrapper {
          position: absolute;
          left: 20px;
          bottom: 40px;

          span {
            display: inline-block;
            text-align: center;
            &:first-of-type {
              margin-right: 20px;
            }
          }

          img {
            width: 80px;
            height: 80px;
          }
        }
      }
    }
  }

  /deep/.el-dialog__header {
    border-bottom-width: 0;
  }

  /deep/.activate-dialog {
    .el-dialog__body {
      padding-left: 32px;
      padding-right: 32px;
    }
  }

  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #303133;
    line-height: 1.6;
  }

  .tips {
    position: relative;
    padding: 0 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #303133;

    i {
      position: absolute;
      color: #67c23a;
      margin-right: 10px;
      top: 2px;
      left: 0;
    }
  }

  .footer {
    text-align: right;
    padding: 37px 10px 10px;
  }
}
</style>
